import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  matchSelected: null,
};

const matchSlice = createSlice({
  name: "match",
  initialState,
  reducers: {
    setMatchSelected: (state, action) => {
      state.matchSelected = {
        matchData: action.payload.matchData,
      };
    },
  },
});

export const { setMatchSelected } = matchSlice.actions;
export default matchSlice.reducer;
